export const validBettingSplitsQuery = {
  bool: {
    must: [
      {
        exists: {
          field: 'betCount',
        },
      },
      {
        exists: {
          field: 'betPercentage',
        },
      },
      {
        exists: {
          field: 'stakeBetDiff',
        },
      },
      {
        exists: {
          field: 'stakePercentage',
        },
      },
      {
        exists: {
          field: 'teamData',
        },
      },
    ],
  },
};
